export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-960-16951ceb6f353fd18aa557f60df47613.png";